import http from "@/settings/apiSettings"

class RoluriDataService {
    get(): Promise<any> {
      return http.clientAuth.get("/AUTH_RoluriUtilizatori/GetRoluriUtilizatori");
    }
    save(data: any): Promise<any> {
            return http.clientAuth.post("/auth/AddRoluriUtilizatori", data);
          }
    update(id: string, data: any): Promise<any> {
  return http.clientAuth.patch(`/auth/UpdateRoluri?key=${id}`, data);
}

}

export default new RoluriDataService();